import React, { useState } from "react";
import { motion } from "framer-motion";
import { useApp } from "@/lib/store";

function OptionList({ options, onSelect, testidPrefix }) {
  return (
    <div className="space-y-3">
      {options.map((o) => (
        <button
          key={o.id}
          data-testid={`${testidPrefix}-${o.id}`}
          onClick={() => onSelect(o.id)}
          className="w-full text-left ss-card ss-tap ss-focus p-4 min-h-[52px] text-[15px]"
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export default function Feedback({ reportedChangeOptions, presetAttempted, onComplete }) {
  const { content } = useApp();
  const [attempted, setAttempted] = useState(presetAttempted || null);
  const [reason, setReason] = useState(null);
  const [helpfulness, setHelpfulness] = useState(null);
  const [phase, setPhase] = useState(presetAttempted === "no" ? "reason" : "attempted");

  const finish = (change) => {
    onComplete({
      attempted,
      noncompletion_reason: reason,
      helpfulness,
      reported_change: change || null,
      created_at: new Date().toISOString(),
    });
  };

  const Block = ({ children }) => (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="px-6 pt-10 pb-28"
    >
      {children}
    </motion.div>
  );

  if (phase === "attempted") {
    return (
      <Block>
        <h2 className="font-serif-display text-3xl mb-6">Were you able to try it?</h2>
        <OptionList
          testidPrefix="fb-attempted"
          options={content.attempted_options}
          onSelect={(id) => { setAttempted(id); setPhase(id === "no" ? "reason" : "helpfulness"); }}
        />
      </Block>
    );
  }

  if (phase === "reason") {
    return (
      <Block>
        <h2 className="font-serif-display text-3xl mb-6">What got in the way?</h2>
        <OptionList
          testidPrefix="fb-reason"
          options={content.noncompletion_reasons}
          onSelect={(id) => { setReason(id); setPhase("helpfulness"); }}
        />
      </Block>
    );
  }

  if (phase === "helpfulness") {
    return (
      <Block>
        <h2 className="font-serif-display text-3xl mb-6">Did it help?</h2>
        <OptionList
          testidPrefix="fb-help"
          options={content.helpfulness_options}
          onSelect={(id) => { setHelpfulness(id); setPhase("change"); }}
        />
      </Block>
    );
  }

  return (
    <Block>
      <h2 className="font-serif-display text-3xl mb-6">What changed most?</h2>
      <OptionList
        testidPrefix="fb-change"
        options={reportedChangeOptions || []}
        onSelect={(id) => finish(id)}
      />
      <button
        data-testid="fb-skip-change"
        onClick={() => finish(null)}
        className="mt-4 text-[14px] text-[#6B6B6B] hover:text-[#1A1A1A] ss-focus transition-colors"
      >
        Skip
      </button>
    </Block>
  );
}
